export default {
  brand: {
    name: 'Helper Casino'
  },
  nav: {
    home: 'Home',
    live: 'Live',
    slots: 'Slots',
    sports: 'Sports',
    minigames: 'Mini Games',
    mini: 'Mini',
    fishing: 'Fishing',
    mypage: 'My Page',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    event: 'Events',
    attendance: 'Attendance',
    newBadge: 'NEW',
    newBadgeAria: 'New attendance menu',
    notice: 'Notices',
    support: 'Support',
    slip: 'Messages',
    betting: 'Bet History',
    login: 'Log In',
    logout: 'Log Out',
    signup: 'Sign Up',
    menuOpen: 'Open menu',
    menuClose: 'Close menu',
    telegramInquiry: 'Telegram Support',
    telegramLiveSupport: 'Live Support',
    mobilePrimary: 'Primary menu',
    headerPoint: 'Points',
    headerPointConvert: 'Convert',
    onlineUsers: 'Online',
    onlineUsersAria: '{count} users currently online'
  },
  sidebar: {
    ageRestrictionTitle: 'Adults Only',
    ageRestrictionDesc: 'You must be 19 or older to use this site.',
    tetherGuideTitle: 'How to Buy USDT & Create a Wallet Address',
    tetherGuideDesc: 'Easy step-by-step guide for beginners'
  },
  footer: {
    ariaLabel: 'Site footer'
  },
  maintenance: {
    title: 'Maintenance Notice',
    defaultMessage: 'The site is currently under maintenance. Please try again later.'
  },
  common: {
    close: 'Close',
    confirm: 'OK',
    backToList: 'Back to list',
    loading: 'Loading...',
    refresh: 'Refresh',
    balanceRefresh: 'Refresh balance',
    prev: 'Previous',
    next: 'Next',
    copySuccess: 'Copied to clipboard.',
    copyFail: 'Failed to copy.',
    telegramMissing: 'Telegram contact is not available.',
    siteLoadError: 'Failed to load site information.',
    alertTitle: 'Notice',
    empty: 'No data available.',
    noTitle: '(No title)'
  },
  auth: {
    loginTitle: 'Log In',
    signupTitle: 'Sign Up',
    signupDesc: 'Please fill in the details below to complete registration.',
    loginId: 'Username',
    loginIdPlaceholder: 'Username',
    password: 'Password',
    passwordPlaceholder: 'Password',
    passwordShow: 'Show password',
    passwordHide: 'Hide password',
    loginSubmit: 'Log In',
    loginSubmitting: 'Signing in...',
    loginEmptyError: 'Please enter your username and password.',
    loginFail: 'Login failed.',
    loginSuccess: 'You are now logged in.',
    logoutSuccess: 'You have been logged out.',
    accountUnavailable: 'This account cannot be used.',
    wrongCredentials: 'Invalid username or password.',
    accountNotApproved: 'This account has not been approved.',
    sessionExpired: 'Your session has expired.',
    sessionInvalid: 'Your login session is invalid.',
    sessionNotFound: 'No login session found. Please sign in again.',
    sessionDoubleLogin: 'You were signed out because your account was used on another device.',
    sessionNetwork: 'Unable to reach the server. Please sign in again.',
    signupPrompt: 'Get started with a quick sign-up.',
    signupLink: 'Sign up now',
    nickname: 'Nickname',
    nicknamePlaceholder: '2–12 characters',
    loginIdRulePlaceholder: '4–12 letters or numbers',
    passwordRulePlaceholder: '4–20 characters',
    passwordConfirm: 'Confirm password',
    passwordConfirmPlaceholder: 'Re-enter password',
    phone: 'Mobile number',
    sendCode: 'Send code',
    resendCode: 'Resend',
    confirmCode: 'Verify',
    codePlaceholder: '6-digit code',
    referralCode: 'Referral code',
    referralCodePlaceholder: 'Enter referral code',
    referralHint: 'If you do not know a referral ID, please',
    referralHintSuffix: 'contact us.',
    signupSubmit: 'Sign Up',
    signupSubmitting: 'Creating account...',
    hasAccount: 'Already have an account?',
    goLogin: 'Log in',
    phoneVerified: 'Mobile verification completed.',
    phoneNeedVerify: 'Please complete mobile verification.',
    phoneInvalid: 'Please check your mobile number.',
    phoneSendFail: 'Failed to send verification code.',
    phoneVerifyFail: 'Invalid verification code.',
    phoneNeedCode: 'Please request a verification code first.',
    errorLoginIdRequired: 'Please enter a username.',
    errorLoginIdFormat: 'Username must be 4–12 letters or numbers.',
    errorNicknameRequired: 'Please enter a nickname.',
    errorNicknameLength: 'Nickname must be 2–12 characters.',
    errorPasswordRequired: 'Please enter a password.',
    errorPasswordLength: 'Password must be 4–20 characters.',
    errorPasswordConfirmRequired: 'Please confirm your password.',
    errorPasswordMismatch: 'Passwords do not match.',
    errorReferralRequired: 'Please enter a referral code.',
    errorReferralInvalid: 'Please check the referral code.',
    errorDuplicateLoginId: 'This username is already taken.',
    errorDuplicateNickname: 'This nickname is already taken.',
    errorDuplicateIp: 'An account already exists from this IP address.',
    signupFail: 'Sign-up failed.',
    signupSuccess: 'Registration completed successfully.',
    signupSuccessLogin: 'Registration complete. Please log in.'
  },
  games: {
    hotTitle: 'Hot Games',
    providersTitle: 'Game Providers',
    hotProvidersTitle: 'Popular Providers',
    hotProvidersSubtitle: 'Select a provider to browse slots or enter the live lobby.',
    liveTitle: 'Live',
    liveSubtitle: 'Select a provider to enter the lobby after logging in.',
    slotsTitle: 'Slots',
    slotsSubtitle: 'Select a provider to browse games without logging in.',
    sportsTitle: 'Sports',
    sportsSubtitle: 'Sports Betting',
    minigameTitle: 'Mini Games',
    fishingTitle: 'Fishing',
    list: 'Game List',
    search: 'Search games',
    searchPlaceholder: 'Enter keyword',
    loading: 'Loading games...',
    loadingProviders: 'Loading providers...',
    loadingSports: 'Loading sports...',
    empty: 'No games to display.',
    emptyProviders: 'No providers to display.',
    emptySearch: 'No search results.',
    expand: 'Show more',
    collapse: 'Show less',
    play: 'Play',
    demo: 'Free Demo',
    previewTagline: 'Play now or try the free demo.',
    recentTitle: 'Recently Played',
    recentSubtitle: 'Quickly relaunch your recently played games.',
    recentBadge: 'RECENT',
    recentEmpty: 'No recently played games yet.',
    frameTitle: 'Game Play',
    frameEyebrow: 'Live Game',
    frameLoading: 'Loading game...',
    frameFullscreen: 'Fullscreen',
    frameExitFullscreen: 'Exit fullscreen',
    gameCountFiltered: '{shown} of {total}',
    gameCountTotal: '{total} games total',
    sportsPreparing: 'Sports betting is being prepared.',
    loadError: 'Failed to load games.',
    launchError: 'Failed to launch game.',
    demoError: 'Failed to launch demo.',
    sportsLaunchError: 'Failed to launch sports game.',
    providerNotFound: 'Unable to verify provider information.',
    providerNotFoundSports: 'Sports provider {provider} not found.',
    providerNotFoundMinigame: 'Provider {provider} not found.',
    categorySlot: 'Slots',
    categoryLive: 'Live',
    categoryFishing: 'Fishing',
    categoryMini: 'Mini',
    categorySports: 'Sports',
    categoryAll: 'All',
    categoryOther: 'Other'
  },
  jackpot: {
    title: 'Live Jackpot',
    slogan: 'Luck grows as it accumulates!',
    currentAmount: 'Current Jackpot',
    mega: 'MEGA',
    live: 'Accumulating in real time'
  },
  popup: {
    aria: 'Popup notice',
    hide24h: 'Hide for 24 hours',
    close: 'Close',
    closeAll: 'Close all popups'
  },
  slip: {
    title: 'Messages',
    desc: 'View your inbox messages.',
    loading: 'Loading messages...',
    emptyAll: 'No messages received.',
    emptyUnread: 'No unread messages.',
    emptyRead: 'No read messages.',
    loadError: 'Failed to load messages.',
    reload: 'Refresh',
    reloadAria: 'Refresh message list',
    filterAria: 'Message filter',
    prevPage: 'Previous',
    nextPage: 'Next',
    colNo: 'No.',
    colStatus: 'Status',
    colTitle: 'Subject',
    colDate: 'Date',
    noTitle: '(No title)',
    unreadCount: 'Unread ({count})',
    unreadAria: '{count} unread messages',
    headerNotice: 'You have unread messages.',
    headerNoticeAria: 'View unread messages',
    filterAll: 'All',
    filterUnread: 'Unread',
    filterRead: 'Read',
    statusUnread: 'Unread',
    statusRead: 'Read',
    detailLoadError: 'Failed to load message content.',
    detailDefaultTitle: 'Message',
    unreadCheckMessage: 'Please check your unread messages.',
    unreadCheckConfirm: 'View messages'
  },
  support: {
    title: 'Support',
    desc: 'Submit a new inquiry and view your inquiry history.',
    composeTitle: 'New Inquiry',
    fieldTitle: 'Subject',
    fieldTitlePlaceholder: 'Enter inquiry subject',
    fieldContent: 'Message',
    fieldContentPlaceholder: 'Enter your inquiry',
    submit: 'Submit inquiry',
    submitting: 'Submitting...',
    historyTitle: 'Inquiry History',
    historyReloadAria: 'Refresh inquiry history',
    loading: 'Loading inquiries...',
    loadError: 'Failed to load inquiries.',
    empty: 'No inquiries found.',
    colNo: 'No.',
    colStatus: 'Status',
    colTitle: 'Subject',
    colDate: 'Date',
    statusAnswered: 'Answered',
    statusPending: 'Pending',
    errorTitleRequired: 'Please enter a subject.',
    errorContentRequired: 'Please enter a message.',
    submitFail: 'Failed to submit inquiry.',
    submitSuccess: 'Your inquiry has been submitted.',
    detailDefaultTitle: 'Inquiry Details',
    detailQuestionTitle: 'Your inquiry',
    detailAnswerTitle: 'Reply',
    detailAnswerPending: 'Awaiting reply.',
    detailLoadError: 'Failed to load inquiry details.'
  },
  notice: {
    title: 'Notices',
    eventTitle: 'Events',
    tabNotice: 'Notices',
    tabPopup: 'Popup Notices',
    categoryNotice: 'Notice',
    categoryPopup: 'Popup',
    categoryEvent: 'Event',
    priority: 'Important',
    colNo: 'No.',
    colCategory: 'Category',
    colDate: 'Date',
    colTitle: 'Title',
    loadingNotice: 'Loading notices...',
    loadingEvent: 'Loading events...',
    emptyNotice: 'No notices available.',
    emptyEvent: 'No events available.',
    errorNotice: 'Failed to load notices.',
    errorEvent: 'Failed to load events.',
    detailDefaultTitle: 'Notice',
    detailLoadError: 'Failed to load notice content.'
  },
  betting: {
    title: 'Bet History',
    desc: 'Review your recent game betting records.',
    startDate: 'Start date',
    endDate: 'End date',
    gameName: 'Game name',
    gameNamePlaceholder: 'Search game name',
    search: 'Search',
    totalBet: 'Total bet',
    totalWin: 'Total win',
    profit: 'Profit/Loss',
    loading: 'Loading bet history...',
    loadError: 'Failed to load bet history.',
    empty: 'No bet history found.',
    colDateTime: 'Date/Time',
    colProvider: 'Provider',
    colGameName: 'Game',
    colCategory: 'Category',
    colBetAmount: 'Bet',
    colWinAmount: 'Win',
    colPreBalance: 'Before',
    colAfterBalance: 'After',
    categorySlot: 'Slots',
    categoryLive: 'Live',
    categoryFishing: 'Fishing',
    categoryMini: 'Mini',
    categorySports: 'Sports',
    categoryAll: 'All',
    categoryOther: 'Other',
    errorNoLogin: 'Session expired. Please log in again.',
    errorNoDateRange: 'Please select a date range.',
    errorDateRange: 'Start date cannot be later than end date.'
  },
  attendance: {
    title: 'Attendance',
    desc: 'Check in daily and earn consecutive attendance rewards.',
    prevMonth: 'Previous month',
    nextMonth: 'Next month',
    weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    today: 'Today',
    streakLabel: 'Consecutive days',
    notChecked: 'Not checked in',
    streakDays: '{days} days',
    checkIn: 'Check in',
    checkInDone: 'Checked in',
    checkInSuccess: 'Attendance check-in completed.',
    alreadyChecked: 'You have already checked in today.',
    notEligible: 'You need at least {amount} in deposits today to check in.',
    checkInFail: 'Check-in failed.',
    loading: 'Loading...',
    loadError: 'Failed to load attendance information.',
    checkedAria: 'Checked in on {date}',
    todayAria: 'Today {date}',
    checkedShort: 'Done',
    rewardTitle: '▶ Attendance rewards',
    reward1: '5 consecutive days: 30,000 points',
    reward2: '10 consecutive days: 50,000 points',
    reward3: '20 consecutive days: 80,000 points',
    reward4: '30 consecutive days: 100,000 points',
    noticeTitle: '▶ Important notes',
    notice1: 'A daily deposit of at least {amount} is required for attendance.',
    notice2: 'Awarded points can be exchanged after {percent} rolling.',
    notice3: 'Only consecutive daily check-ins count.',
    notice4: 'Consecutive attendance resets on the 1st of each month.',
    notice5: 'Repeatedly meeting only minimum rolling to join this event may result in restrictions.'
  },
  mypage: {
    title: 'My Page',
    desc: 'View your account information and balances.',
    loading: 'Loading account info...',
    loadError: 'Failed to load account info.',
    profileTitle: 'Account Info',
    walletTitle: 'Balances',
    inquiryTitle: '1:1 Inquiry',
    inquiryDesc: 'Support inquiry history',
    bettingTitle: 'Bet History',
    bettingDesc: 'Recent game betting records',
    loginId: 'Username',
    memberLevel: 'Member level',
    name: 'Name',
    phone: 'Mobile',
    referralCode: 'Referral code',
    referralCodeEmpty: 'None',
    bankHolder: 'Account holder',
    bankName: 'Bank',
    bankAccount: 'Account number',
    joinDate: 'Join date',
    lastLogin: 'Last login',
    balance: 'Balance',
    bonus: 'Bonus',
    apiBalance: 'Game wallet balance',
    point: 'Points',
    accountStatus: 'Account status',
    lastDepositDate: 'Last deposit',
    lastBetDate: 'Last bet',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    pointConvert: 'Convert points',
    goTo: 'Go',
    pointConvertTitle: 'Convert Points',
    pointConvertLoading: 'Loading balance info...',
    pointConvertAmount: 'Points to convert',
    pointConvertAmountPlaceholder: 'Enter points to convert',
    pointConvertAll: 'All',
    pointConvertSubmit: 'Convert points to balance',
    pointConvertSubmitting: 'Converting...',
    pointConvertNote1: 'Convert your points to balance.',
    pointConvertNote2: 'Conversion is applied immediately.',
    pointConvertLoadError: 'Failed to load balance info.',
    pointConvertAmountRequired: 'Please enter points to convert.',
    pointConvertAmountExceed: 'Cannot convert more than your available points.',
    pointConvertFail: 'Point conversion failed.',
    pointConvertSuccess: 'Points converted successfully.'
  },
  member: {
    role1: 'Admin',
    role2: 'Master',
    role3: 'Agent',
    role4: 'Root Agent',
    role5: 'Player',
    role6: 'BBS',
    role7: 'CP',
    role8: 'MJ',
    role9: 'Member',
    levelTemplate: 'Level {level}',
    statusNormal: 'Active',
    statusSuspended: 'Suspended'
  },
  wallet: {
    depositTitle: 'Deposit',
    withdrawTitle: 'Withdraw',
    depositTabBank: 'Bank Deposit',
    depositTabTether: 'USDT Deposit',
    withdrawTabBank: 'Bank Withdraw',
    withdrawTabTether: 'USDT Withdraw',
    depositTabAria: 'Deposit method',
    withdrawTabAria: 'Withdraw method',
    subtitleBoth: 'You can deposit and withdraw via bank transfer or USDT (Tether).',
    subtitleTether: 'You can deposit and withdraw via USDT (Tether).',
    subtitleBank: 'You can deposit and withdraw via bank transfer.',
    tetherDepositGuideTitle: 'USDT Deposit Guide',
    bankDepositGuideTitle: 'Bank Deposit Guide',
    bankWithdrawGuideTitle: 'Bank Withdraw Guide',
    tetherWithdrawGuideTitle: 'USDT Withdraw Guide',
    tetherDepositGuideParagraph1: 'To deposit with USDT (Tether), enter the amount and your wallet address below, then submit a deposit request.',
    tetherDepositGuideParagraph2: 'After requesting, send to the provided USDT address (TRC20) and your USD amount will be reflected based on the USDT rate.',
    tetherDepositGuideParagraph3Prefix: 'For address or QR inquiries, contact ',
    tetherDepositGuideParagraph3Suffix: ' or customer support.',
    bankDepositGuideParagraph1: 'To deposit by bank transfer, enter the deposit amount and account details (bank name, depositor name, account number), then submit a request.',
    bankDepositGuideParagraph2: 'After requesting, transfer to the dedicated deposit account provided and it will be confirmed and processed.',
    bankDepositGuideParagraph3: 'Verification may be delayed for third-party names or mismatched amounts. Please deposit the exact requested amount.',
    bankWithdrawGuideParagraph1: 'For bank withdrawal, enter the withdrawal amount and bank name, account holder, and account number, then submit a request.',
    bankWithdrawGuideParagraph2Prefix: 'Please verify your registered bank details are accurate. For inquiries, contact ',
    bankWithdrawGuideParagraph2Suffix: '.',
    tetherWithdrawGuideParagraph1: 'For USDT (Tether) withdrawal, enter the withdrawal amount and USDT address (TRC20), then submit a request.',
    tetherWithdrawGuideParagraph2Prefix: 'For withdrawal procedure or USDT address inquiries, contact ',
    tetherWithdrawGuideParagraph2Suffix: '.',
    tetherDepositRequestTitle: 'USDT Deposit Request',
    bankDepositRequestTitle: 'Bank Deposit Request',
    bankWithdrawRequestTitle: 'Bank Withdraw Request',
    tetherWithdrawRequestTitle: 'USDT Withdraw Request',
    depositAmountLabel: 'Deposit amount',
    withdrawAmountLabel: 'Withdraw amount',
    amountPlaceholder: 'e.g. {amount}',
    quick10k: '10K',
    quick30k: '30K',
    quick50k: '50K',
    quick100k: '100K',
    quick500k: '500K',
    quick1m: '1M',
    quick10m: '10M',
    reset: 'Reset',
    required: 'Required',
    checking: 'Checking...',
    requesting: 'Requesting...',
    walletAddressLabel: 'Your wallet address',
    walletAddressPlaceholder: 'Enter your wallet address',
    walletCheck: 'Check wallet',
    walletBalanceLabel: 'Balance',
    walletBalanceUnit: 'USDT',
    walletCheckHintDeposit: 'Tap Check wallet to verify your TRC20 USDT balance before requesting a deposit.',
    walletCheckHintWithdraw: 'Tap Check wallet to verify your TRC20 USDT balance before requesting a withdrawal.',
    tetherAddressLabel: 'USDT address',
    tetherAddressPlaceholder: 'Enter your USDT (Tether) TRC20 withdrawal address',
    bankInfoGroup: 'Bank details',
    bankNameLabel: 'Bank name',
    bankNamePlaceholder: 'e.g. KB Bank',
    depositorNameLabel: 'Depositor name',
    depositorNamePlaceholder: 'Depositor name',
    accountHolderLabel: 'Account holder',
    accountHolderPlaceholder: 'Legal name',
    accountNumberLabel: 'Account number',
    accountNumberPlaceholder: 'Numbers only, no hyphens',
    availableBalanceLabel: 'Available to withdraw',
    checkAvailableBalance: 'Check available amount',
    depositRequest: 'Request deposit',
    withdrawRequest: 'Request withdrawal',
    supportInquiry: 'Contact support',
    tetherAddressGuide: 'USDT address info',
    networkTrc20: 'TRC20',
    networkHint: 'Please deposit via TRC20 (Tron) network only.',
    requestedAmount: 'Requested amount: {amount} USDT',
    qrAlt: 'USDT deposit QR code',
    qrLoading: 'Generating QR...',
    qrCaption: 'Scan TRC20 QR to deposit',
    copyAddress: 'Copy address',
    copiedAddress: 'Copied',
    addressCopied: 'Address copied.',
    tetherAddressCopied: 'USDT address copied.',
    addressCopyFail: 'Failed to copy address.',
    copyBankName: 'Copy bank name',
    copyAccountNo: 'Copy account number',
    copyHolder: 'Copy account holder',
    bankAccountGuide: 'Deposit account info',
    bankDepositHint: 'Please deposit {amount} to the account below.',
    bankName: 'Bank',
    accountNumber: 'Account number',
    accountHolder: 'Account holder',
    depositHistoryTitle: 'Deposit History',
    withdrawHistoryTitle: 'Withdraw History',
    historyDesc: 'All requests including pending and completed are shown.',
    historyReloadDeposit: 'Refresh deposit history',
    historyReloadWithdraw: 'Refresh withdraw history',
    loadingDepositHistory: 'Loading deposit history...',
    loadingWithdrawHistory: 'Loading withdraw history...',
    loadDepositHistoryError: 'Failed to load deposit history.',
    loadWithdrawHistoryError: 'Failed to load withdraw history.',
    emptyDepositHistory: 'No deposit history.',
    emptyWithdrawHistory: 'No withdraw history.',
    colRequestDate: 'Requested',
    colType: 'Type',
    colAmount: 'Amount',
    colDepositInfo: 'Deposit info',
    colWithdrawInfo: 'Withdraw info',
    colMemo: 'Memo',
    colStatus: 'Status',
    colProcessedDate: 'Processed',
    statusRequest: 'Requested',
    statusWaiting: 'Pending',
    statusComplete: 'Completed',
    statusCancel: 'Cancelled',
    statusDelete: 'Deleted',
    statusUnknown: 'Unknown',
    chargeTypeNormal: 'Standard deposit',
    chargeTypeForce: 'Manual credit',
    chargeTypeOther: 'Other',
    withdrawTypeNormal: 'Standard withdrawal',
    withdrawTypeForce: 'Manual debit',
    withdrawTypeOther: 'Other',
    depositMinAmount: 'Minimum deposit amount is {amount}.',
    depositWalletRequired: 'Please enter your wallet address.',
    depositWalletCheckRequired: 'Please complete wallet verification before requesting a deposit.',
    depositRateLoading: 'Loading USDT exchange rate. Please try again shortly.',
    depositSuccess: 'Deposit request submitted.',
    depositFail: 'Deposit request failed. Please try again later.',
    depositPending: 'A deposit request is already in progress. Please wait until it is processed.',
    pgDepositGuideTitle: 'Deposit guide',
    pgDepositGuideBody: 'Select CashApp, Chime, Google Pay, or Apple Pay, pick an amount, then press Request deposit to open the payment page. Your balance is credited automatically once the payment completes.',
    pgDepositRequestTitle: 'Deposit request',
    pgWayCodeLabel: 'Payment method',
    pgWayCashApp: 'CashApp',
    pgWayChime: 'Chime',
    pgWayGooglePay: 'Google Pay',
    pgWayApplePay: 'Apple Pay',
    pgWayCodeRequired: 'Please select a payment method.',
    pgAmountSelectLabel: 'Select deposit amount',
    pgAmountUnselected: 'Please select an amount',
    pgAmountRequired: 'Please select a deposit amount below.',
    pgDepositOpenCashier: 'Open payment page',
    pgDepositRedirecting: 'Opening payment page…',
    pgWithdrawGuideTitle: 'Withdrawal guide',
    pgWithdrawGuideBody: 'Select CashApp or Chime, enter your payout details, then request a withdrawal. The payout request is sent to PG immediately.',
    pgWithdrawRequestTitle: 'Withdrawal request',
    pgCashtag: 'Cashtag',
    pgCashtagPlaceholder: '$username',
    pgEmail: 'Email',
    pgEmailPlaceholder: 'name@example.com',
    pgCardNumber: 'Card number',
    pgCardNumberPlaceholder: 'Card number',
    pgCardValid: 'Expiry',
    pgCardValidPlaceholder: 'MM/YYYY',
    pgAccountNumber: 'Account number',
    pgAccountNumberPlaceholder: 'Account number',
    pgRoutingNumber: 'Routing number',
    pgRoutingNumberPlaceholder: '9-digit routing number',
    pgChimeSign: 'Chime account',
    pgChimeSignPlaceholder: '$chimeSign',
    pgZelleSign: 'Zelle (email/phone)',
    pgZelleSignPlaceholder: 'email or +1phone',
    pgReceiveInfo: 'Payout details',
    pgReceiveInfoPlaceholder: 'Enter your payout details',
    pgReceiveRequired: 'Please enter your payout details.',
    bankNameRequired: 'Please enter bank name.',
    depositorRequired: 'Please enter depositor name.',
    accountRequired: 'Please enter account number.',
    invalidTronAddress: 'Please enter a valid TRC20 wallet address.',
    walletBalanceFail: 'Failed to check wallet balance.',
    walletBalanceNetworkFail: 'Failed to check wallet balance. Please check your network connection.',
    depositNoteMismatch: 'Deposits that differ from the requested amount may take longer to confirm.',
    withdrawMinAmount: 'Minimum withdrawal amount is {amount}.',
    withdrawBalanceLoading: 'Loading available withdrawal amount. Please try again shortly.',
    withdrawExceedAvailable: 'Withdrawal amount exceeds available balance ({amount}).',
    withdrawExceedBalance: 'Withdrawal amount exceeds available balance. Please review withdrawal rules (wagering requirements and bonus deductions).',
    withdrawPending: 'A withdrawal request is already in progress. Please wait until it is processed.',
    withdrawLimitMinutes: 'Withdrawals can be requested every {minutes} minutes. Please try again later.',
    withdrawLimitGeneric: 'Withdrawal cooldown has not elapsed. Please try again later.',
    withdrawSuccess: 'Withdrawal request submitted.',
    withdrawFail: 'Withdrawal request failed. Please try again later.',
    pgWithdrawCreateFail: 'PG withdrawal request failed. Please try again later.',
    tetherAddressRequired: 'Please enter USDT address.',
    withdrawWalletCheckRequired: 'Please complete wallet verification before requesting a withdrawal.',
    holderRequired: 'Please enter account holder name.',
    availableModalTitle: 'Available Withdrawal Amount',
    availableModalLabel: 'Current available amount',
    refreshBalance: 'Refresh amount',
    amountInfoTitle: 'Amount details',
    amountInfoAria: 'Available withdrawal amount calculation guide',
    totalDeposit: 'Total deposits',
    totalBet: 'Total bets',
    requiredBet: 'Required wagering (total deposit × {percent})',
    heldMoney: 'Balance',
    heldBonus: 'Bonus balance',
    withdrawRule: 'Withdrawal rules',
    formula: 'Formula',
    rulesTitle: 'Withdrawal policy',
    ruleMetSummary: 'Wagering met — full balance available for withdrawal',
    ruleNotMetSummary: 'Wagering not met — bonus deducted from withdrawal',
    formulaCalculating: 'Calculating available withdrawal amount',
    ruleInfoLoading: 'Loading withdrawal policy...',
    conditionChecking: 'Checking withdrawal conditions...',
    conditionLoadFail: 'Failed to load withdrawal conditions.',
    conditionMet: 'Total bets ({totalBet}) exceed required wagering ({requiredBet}). Full balance is available for withdrawal.',
    conditionNotMet: 'Total bets ({totalBet}) are below required wagering ({requiredBet}). Available withdrawal is limited to balance minus bonus.',
    ruleBetMetTitle: 'Wagering requirement met',
    ruleBetMetDesc: 'If total bets exceed total deposits × {percent}, you may withdraw your full balance.',
    ruleBetNotMetTitle: 'Wagering requirement not met',
    ruleBetNotMetDesc: 'If total bets are below the threshold, available withdrawal is limited to balance minus bonus.',
    ruleTotalDepositNote: 'The requested withdrawal amount is deducted upon processing.',
    ruleTotalBetNote: 'Total bets accumulated before the first withdrawal after deposit; reset to 0 upon withdrawal.',
    amountWon: '{amount}',
    rateLabel: '1 USDT = {rate}',
    rateLabelBithumb: 'Bithumb 1 USDT = {rate}',
    rateLabelUsd: '1 USDT ≈ {rate} (pegged)',
    rateLive: 'Live',
    rateConnectFail: 'Failed to connect to Bithumb exchange rate.',
    rateDisconnected: 'Bithumb exchange rate connection lost.',
    networkFeeTitle: 'TRC20 Network Fee',
    networkFeeSubtitle: 'TronGrid official API simulation · may vary',
    networkFeeRefresh: 'Updates every 10s',
    networkFeeEst: 'Estimated fee',
    networkFeeTrxHint: '(~{trx} TRX)',
    networkFeeBaseDeposit: 'Deposit credit USDT',
    networkFeeBaseWithdraw: 'Withdrawal request USDT',
    networkFeeTotalDeposit: 'Amount to send',
    networkFeeTotalWithdraw: 'Amount to receive',
    networkFeeNote: 'Actual fees depend on recipient address and wallet TRX/Energy balance.',
    networkFeeLoading: 'Loading network fee information. Please try again shortly.',
    networkFeeSimpleRequest: 'Request',
    networkFeeSimpleFee: 'Fee',
    networkFeeSimpleLoading: 'Checking fee…',
    chargeMemo: '{krw} = {usdt} USDT',
    withdrawMemo: '{krw} = {usdt} USDT / 수수료 {feeUsdt} USDT'
  },
  lang: {
    title: 'Language',
    changed: 'Language has been updated.'
  },
  payment: {
    depositSubtitleBoth: 'You can request a deposit via bank transfer or USDT (Tether).',
    depositSubtitleTether: 'You can request a deposit via USDT (Tether).',
    depositSubtitleBank: 'You can request a deposit via bank transfer.',
    depositSubtitlePg: 'Deposit via payment gateway. You will be redirected to the cashier.',
    withdrawSubtitleBoth: 'You can request a withdrawal via bank transfer or USDT (Tether).',
    withdrawSubtitleTether: 'You can request a withdrawal via USDT (Tether).',
    withdrawSubtitleBank: 'You can request a withdrawal via bank transfer.',
    withdrawSubtitlePg: 'Request a PG withdrawal. The payout is submitted immediately.'
  }
}
